angular.module('pe4h').controller('Main', function ($scope, $state, $uibModal) {

	$scope.setHamburger();

	$scope.continue = function () {
		$state.go('post-project', { 'zip': $scope.zipcode, 'type': $scope.type.Id });
	}

	$scope.handleClickGetStarted = function () {
		if ($scope.user && $scope.user.IsProfessional)
			$scope.showEngineerCantGetStartedModal();
		else
			$state.go('post-project', {});
	}
	$scope.showEngineerCantGetStartedModal = function () {
		$uibModal.open({
			templateUrl: "modal-professional-email.html"
		});
	};
});